export default "__VITE_ASSET__ghoKjCft__"